'use client';

/**
 * Корневой error boundary App Router: ловит необработанные ошибки рендера на ЛЮБОЙ
 * странице приложения ВНЕ уже существующих точечных boundary (доска, sidebar-виджет).
 * До него белый экран без объяснения и без «Обновить» был штатным исходом любой
 * непойманной ошибки — самый частый фейл на первом пользовательском тесте.
 *
 * Держим само собой достаточным: только inline-стили, никакого antd/провайдеров —
 * этот компонент рендерится в том числе когда что-то в дереве уже сломалось.
 * Более фатальный случай (падение самого RootLayout) закрывает global-error.tsx.
 */
import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Без DSN — тихий no-op (см. instrumentation-client.ts). С DSN — ошибка уедет
    // в трекер с digest'ом, по которому её видно в серверных логах Next.
    Sentry.captureException(error);
  }, [error]);

  return (
    <div
      style={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f5f5f5',
        padding: 24,
        textAlign: 'center',
      }}
    >
      <p style={{ marginBottom: 4, color: '#333', fontSize: 16, fontWeight: 500 }}>
        Что-то пошло не так
      </p>
      <p style={{ marginBottom: 16, color: '#666', fontSize: 13, maxWidth: 380 }}>
        Мы уже знаем об ошибке. Попробуйте повторить действие, а если не помогает —
        обновите страницу.
      </p>
      <div style={{ display: 'flex', gap: 8 }}>
        <button
          type="button"
          onClick={() => reset()}
          style={{
            padding: '8px 16px',
            background: '#2f6fed',
            color: '#fff',
            border: 'none',
            borderRadius: 6,
            cursor: 'pointer',
            fontSize: 14,
          }}
        >
          Повторить
        </button>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            padding: '8px 16px',
            background: '#fff',
            color: '#333',
            border: '1px solid #d9d9d9',
            borderRadius: 6,
            cursor: 'pointer',
            fontSize: 14,
          }}
        >
          Обновить страницу
        </button>
      </div>
      {error.digest && (
        <p style={{ marginTop: 16, color: '#999', fontSize: 12 }}>
          Код ошибки: {error.digest}
        </p>
      )}
    </div>
  );
}
